const state = {
  vacancy: {
    name: "",
  },
  complementaryKeywords: [],
  complementaryRoles: [],
};

const getters = {
  getVacancy: (state) => state.vacancy,
  complementaryKeywords: (state) => state.complementaryKeywords,
  complementaryRoles: (state) => state.complementaryRoles,
};

const mutations = {
  setVacancy(state, vacancy) {
    state.vacancy = vacancy;
  },
  setComplementaryKeywords(state, keywords) {
    state.complementaryKeywords = keywords;
  },
  setComplementaryRoles(state, roles) {
    state.complementaryRoles = roles;
  },
  clearVacancyState(state) {
    state.vacancy = {
      name: "",
    };
    state.complementaryKeywords = [];
    state.complementaryRoles = [];
  },
};

const actions = {
  updateVacancy: async function({ commit, dispatch }, vacancy) {
    commit("setVacancy", vacancy);
    await dispatch("fetchComplementaryData");
    // Após buscar, atualiza os steps dinamicamente
    const keywords = vacancy.complementaryKeywords || this.state.vacancy.complementaryKeywords;
    const roles = vacancy.complementaryRoles || this.state.vacancy.complementaryRoles;
    dispatch("step/updateStepsDynamically", { keywords, roles }, { root: true });
  },
  clearVacancyState({ commit }) {
    commit("clearVacancyState");
  },
  async fetchComplementaryData({ commit, state }) {
    // Precisa do uuid da vaga
    const uuid = state.vacancy.uuid;
    if (!uuid || uuid === 'undefined') {
      // Se não há uuid válido, limpa os dados e não tenta buscar
      commit('setComplementaryKeywords', []);
      commit('setComplementaryRoles', []);
      return;
    }
    try {
      const api = (await import('../../services/api')).default;
      const response = await api.get(`/api/v2/turbo/matching/personas/${uuid}`);
      const { keywords = [], experiences: roles = [] } = response.data.data || {};
      commit('setComplementaryKeywords', keywords.map(k => k.name) || []);
      commit('setComplementaryRoles', roles.map(r => r.name) || []);
    } catch (e) {
      commit('setComplementaryKeywords', []);
      commit('setComplementaryRoles', []);
      // Pode logar erro se quiser
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
